/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const FlagTriangleRight = [
  "svg",
  defaultAttributes,
  [["path", { d: "M7 22V2l10 5-10 5" }]]
];

export { FlagTriangleRight as default };
//# sourceMappingURL=flag-triangle-right.js.map
